export const CapitalizeEveryFirstLetter = (string) => {
    var splitStr = string.toLowerCase().split(' ');
     for (var i = 0; i < splitStr.length; i++) {
         // You do not need to check if i is larger than splitStr length, as your for does that for you
         // Assign it back to the array
         splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1).toLowerCase();     
     }
     // Directly return the joined string
     return splitStr.join(' ')
}

export const joinByUnderscore = (string) => {
    var splitStr = string.toLowerCase().split(' ')

    return splitStr.join('_')
}

export const getFirstWord = (string) => {
    var firstWord = ''
    const words = string.split(" ")

    firstWord = words[0]
    
    return firstWord
}